"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTopRowWrapper = exports.StyledTitleWrapper = exports.StyledTitle = exports.StyledRightButtonWrapper = exports.StyledPanelHeaderWrapper = exports.StyledLeftButtonWrapper = exports.StyledCloseButton = exports.StyledBottomRowWrapper = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _button = require("../../button");
var _typography = require("../../typography");
const StyledPanelHeaderWrapper = _styled.default.div`
    width: 100%;
    padding: var(--sds--panel-header--padding--top, var(--sds--panel-header--padding-top, ${_designTokens.space.space40}))
        var(--sds--panel-header--padding--right, var(--sds--panel-header--padding-right, 13px))
        var(--sds--panel-header--padding--bottom, var(--sds--panel-header--padding-bottom, ${_designTokens.space.space20}))
        var(--sds--panel-header--padding--left, var(--sds--panel-header--padding-left, ${_designTokens.space.space45}));
    box-sizing: border-box;
`;
exports.StyledPanelHeaderWrapper = StyledPanelHeaderWrapper;
const StyledTopRowWrapper = _styled.default.div`
    width: 100%;
    max-width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: ${props => props.panelHasChildren ? _designTokens.space.space20 : 0};
    gap: var(--sds--panel-header--gap);
`;
exports.StyledTopRowWrapper = StyledTopRowWrapper;
const StyledBottomRowWrapper = _styled.default.div`
    display: flex;
    margin-top: ${_designTokens.space.space20};

    button {
        margin-right: ${_designTokens.space.space20};
    }
`;
exports.StyledBottomRowWrapper = StyledBottomRowWrapper;
const StyledRightButtonWrapper = _styled.default.div`
    display: grid;
    grid-gap: ${_designTokens.space.space10};
    grid-template-columns: 1fr 1fr;
`;

//The title wrapper ensures the typeramp is vertically aligned with the header buttons at various different typeramp styles
exports.StyledRightButtonWrapper = StyledRightButtonWrapper;
const StyledTitleWrapper = _styled.default.div`
    display: inline-flex;
    align-items: center;
    width: 100%;
    max-width: calc(
        100% - 60px
    ); //60px - the width of the action buttons, so the typeramp can truncate itself properly without moving the buttons
    min-height: 28px;
`;
exports.StyledTitleWrapper = StyledTitleWrapper;
const StyledTitle = (0, _styled.default)(_typography.TypeRampV2)`
    width: 100%;
    color: var(--sds--panel-header--text--color, ${(0, _designTokensReact.color)("color--text--neutral--strong")});
`;
exports.StyledTitle = StyledTitle;
const StyledLeftButtonWrapper = _styled.default.div(_ref => {
  let {
    hasContentBefore
  } = _ref;
  return `
    display: flex;
    align-items: flex-start;
    margin-right: ${hasContentBefore ? _designTokens.space.space10 : 0};

    button:first-of-type {
        margin-right: ${_designTokens.space.space10};
    }
`;
});

// This ensures the close button is always right-aligned. This is necessary when there is no kebab menu.
exports.StyledLeftButtonWrapper = StyledLeftButtonWrapper;
const StyledCloseButton = (0, _styled.default)(_button.Button)`
    grid-column: 2;
`;
exports.StyledCloseButton = StyledCloseButton;
//# sourceMappingURL=StyledPanelHeaderComponents.js.map